var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJsonField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_16212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3752 3.41909C14.7908 3.24682 14.1824 3.59487 14.0139 4.19253L9.61393 19.9425C9.44549 20.5402 9.7858 21.1624 10.3702 21.3347C10.9546 21.507 11.563 21.1589 11.7314 20.5613L16.1314 4.81128C16.2999 4.21362 15.9596 3.59136 15.3752 3.41909ZM18.1458 7.64136C17.7161 8.08081 17.7161 8.79448 18.1458 9.23393L21.2155 12.3769L18.1424 15.5199C17.7127 15.9593 17.7127 16.673 18.1424 17.1125C18.5721 17.5519 19.2699 17.5519 19.6995 17.1125L23.5495 13.175C23.9792 12.7355 23.9792 12.0218 23.5495 11.5824L19.6995 7.64487C19.2699 7.20542 18.5721 7.20542 18.1424 7.64487L18.1458 7.64136ZM7.60299 7.64136C7.1733 7.2019 6.47549 7.2019 6.0458 7.64136L2.1958 11.5789C1.76611 12.0183 1.76611 12.732 2.1958 13.1714L6.0458 17.1089C6.47549 17.5484 7.1733 17.5484 7.60299 17.1089C8.03268 16.6695 8.03268 15.9558 7.60299 15.5164L4.52986 12.3769L7.60299 9.23393C8.03268 8.79448 8.03268 8.08081 7.60299 7.64136Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_16212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white",
    transform: "translate(1.87256 3.37695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsonField);
export default __webpack_public_path__ + "static/media/json-field.0c8156d44446abad340f3e95f8b76fee.svg";
export { ForwardRef as ReactComponent };